import React, { useState } from 'react';
// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// Mui icon
import AddIcon from '@mui/icons-material/Add';
import MinimizeIcon from '@mui/icons-material/Minimize';
import Divider from '@mui/material/Divider';
import TwitterIcon from '@mui/icons-material/Twitter';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

// LOGO 
import footerLogo from '../assets/appbar/243256.svg';
import LogoMob from '../assets/appbar/logo-mob.svg';
import LogoMini from '../assets/appbar/logo-mini.svg';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();
    const [collapse, setCollapse] = useState(null);
    const navigateLinkedin = () => window.open("https://www.linkedin.com/company/kardinalinc/", "_blank");
    const navigateTwitter = () => window.open("https://twitter.com/gokardinal", "_blank");
    const navigateInstagram = () => window.open("https://instagram.com/gokardinal", "_blank");
    const navigateFacebook = () => window.open("https://m.facebook.com/gokardinal", "_blank");
    const navigatePodcaste = () => window.open("https://anchor.fm/kardinal", "_blank");
    const navigateBlog = () => window.open("http://gokardinal.hubspotpagebuilder.eu/travel-policy", "_blank");
    const openLink = (link) => window.open(`https://${link}`, "_blank");
    return (
        <footer>
            <Container>
                <Row className='desktop-row'>
                    <Col sm={12} md={12} lg={3}>
                        <img className='footer-logo' src={footerLogo} alt='AppLogo' />
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <h4>Product</h4>
                        <ul>
                            <li onClick={() => navigate("/travel")}>Flight <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/hotel")}>Accommodation <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/car")}>Car <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/k-care")}>K Care <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/expense-management")}>Expense Management <ArrowRightAltIcon /> </li>
                        </ul>
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <h4>Company</h4>
                        <ul>
                            <li onClick={() => navigate("/customer")}>Customers <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/about")}>About <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/privacy")}>Privacy <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/privacy")}>Terms <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/contact")}>Contact us <ArrowRightAltIcon /> </li>
                        </ul>
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <h4>Resources</h4>
                        <ul>
                            <li onClick={() => navigate("/guides")}>Guides <ArrowRightAltIcon /> </li>
                            <li onClick={navigateBlog}>Blog <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/business-series")}>Business Series <ArrowRightAltIcon /> </li>
                            <li onClick={() => navigate("/faq")}>Help/FAQ <ArrowRightAltIcon /> </li>
                        </ul>
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <h4>Contact</h4>
                        <ul>
                            <li>Call: +234 802 6993 460 <ArrowRightAltIcon /> </li>
                            <li>Whatsapp: Chat us now <ArrowRightAltIcon /> </li>
                            <li onClick={() => openLink("Bookings@gokardinal.com")}>Bookings@gokardinal.com <ArrowRightAltIcon /> </li>
                            <li onClick={() => openLink("Wecare@gokardinal.com")}>Wecare@gokardinal.com <ArrowRightAltIcon /> </li>
                        </ul>
                    </Col>
                </Row>
                <Row className='mobile-row'>
                    <Col sm={12} md={12} lg={3}>
                        <img className='footer-logo' src={LogoMob} alt='AppLogo' />
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <div className='direction-row-corners p-right'>
                            <h4>Product</h4>
                            {collapse === 1 ?
                                <MinimizeIcon sx={{ color: '#40798C' }} onClick={() => setCollapse(null)} />
                                :
                                <AddIcon sx={{ color: '#40798C' }} onClick={() => setCollapse(1)} />
                            }
                        </div>
                        {collapse === 1 &&
                            <ul>
                                <li onClick={() => navigate("/travel")}>Flight <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/hotel")}>Accommodation <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/car")}>Car <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/k-care")}>K Care <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/expense-management")}>Expense Management <ArrowRightAltIcon /> </li>
                            </ul>
                        }
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <div className='direction-row-corners p-right'>
                            <h4>Company</h4>
                            {collapse === 2 ?
                                <MinimizeIcon sx={{ color: '#40798C' }} onClick={() => setCollapse(null)} />
                                :
                                <AddIcon sx={{ color: '#40798C' }} onClick={() => setCollapse(2)} />
                            }
                        </div>
                        {collapse === 2 &&
                            <ul>
                                <li onClick={() => navigate("/customer")}>Customers <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/about")}>About <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/privacy")}>Privacy <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/privacy")}>Terms <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/contact")}>Contact us <ArrowRightAltIcon /> </li>
                            </ul>
                        }
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <div className='direction-row-corners p-right'>
                            <h4>Resources</h4>
                            {collapse === 3 ?
                                <MinimizeIcon sx={{ color: '#40798C' }} onClick={() => setCollapse(null)} />
                                :
                                <AddIcon sx={{ color: '#40798C' }} onClick={() => setCollapse(3)} />
                            }
                        </div>
                        {collapse === 3 &&
                            <ul>
                                <li onClick={() => navigate("/guides")}>Guides <ArrowRightAltIcon /> </li>
                                <li onClick={navigateBlog}>Blog <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/business-series")}>Business Series <ArrowRightAltIcon /> </li>
                                <li onClick={() => navigate("/faq")}>Help/FAQ <ArrowRightAltIcon /> </li>
                            </ul>
                        }
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <div className='direction-row-corners p-right'>
                            <h4>Contact</h4>
                            {collapse === 4 ?
                                <MinimizeIcon sx={{ color: '#40798C' }} onClick={() => setCollapse(null)} />
                                :
                                <AddIcon sx={{ color: '#40798C' }} onClick={() => setCollapse(4)} />
                            }
                        </div>
                        {collapse === 4 &&
                            <ul>
                                <li>Call: +234 802 6993 460 <ArrowRightAltIcon /> </li>
                                <li>Whatsapp: Chat us now <ArrowRightAltIcon /> </li>
                                <li onClick={() => openLink("Bookings@gokardinal.com")}>Bookings@gokardinal.com <ArrowRightAltIcon /> </li>
                                <li onClick={() => openLink("Wecare@gokardinal.com")}>Wecare@gokardinal.com <ArrowRightAltIcon /> </li>
                            </ul>
                        }
                    </Col>
                </Row>
            </Container>
            <Divider />
            <Container>
                <Row className='footer-last-section-row'>
                    <div>
                        <img src={LogoMini} alt='LogoIcon' />
                        <h5>Travel ecosytem for businesses in Africa</h5>
                    </div>
                    <div>
                        <img src={require('../assets/LinkedInIcon.png')} alt='footer_icon' onClick={navigateLinkedin} />
                        <TwitterIcon sx={{ color: "#40798C", width: "1.1rem", height: "1.1rem" }} onClick={navigateTwitter} />
                        <img src={require('../assets/FbIcon.png')} alt='footer_icon' onClick={navigateFacebook} />
                        <img src={require('../assets/InstaIcon.png')} alt='footer_icon' onClick={navigateInstagram} />
                        <PodcastsIcon sx={{ color: "#40798C", width: "1.1rem", height: "1.1rem" }} onClick={navigatePodcaste} />
                    </div>
                    <div>
                        <p>2a, Alara street, Sabo Yaba. Lagos Nigeria</p>
                        <p>© 2022 Kardinal Technologies, Inc.</p>
                        <p>All rights reserved.</p>
                    </div>

                </Row>
            </Container>
        </footer>
    );
};

export default Footer;